import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, createStyles, Drawer, DrawerProps, Grid, makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { MatterDetails } from '../MatterSummaryRepository';
import { Field, Form } from 'react-final-form';
import { Rating } from '@material-ui/lab';
import { client } from '../..';
import { showNotification } from '../../App';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { mainTheme } from '../../Theme';
import { formatNumber } from '../../helpers/ChartHelper';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import { FormApi } from 'final-form';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import { SkeletonTablePanel } from '../../components/loading/SkeletonTablePanel';
import DataTables from '../../components/DataTables';
import { LightTooltip } from '../../helpers/commonHelper';
import InfoIcon from '@material-ui/icons/Info';
import { RvLoader } from '../../components/Loader';
import DialogBox from '../../Dashboard/Component/DialogBox';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        loaderWrapper: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        root: {
            maxWidth: '900px',
            padding: '15px',
            width: '100%',
        },
        agWrapper: {
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            gap: '10px',
            '& .ag-theme-material': {
                flex: 1
            },
            '& .ag-status-bar': {
                border: 'none',
            }
        },
        infoBody: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'flex-start',
        },
        learnMoreContainer: {
            padding: '10px',
        },
        infoContainer: {
            display: 'flex',
            flexFlow: 'column',
            gap: '5px',
            paddingBottom: '10px',
        },
        infoWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontSize: '14px',
        },
        infoTitle: {
            fontWeight: 'bold',
            // color: mainTheme.TemplateColor.Primary,
        },
        infoValue: {
            // color: mainTheme.TemplateColor.Primary,
        },
        cardContainer: {
            display: 'flex',
            flexFlow: 'column', 
            gap: '10px',
        },
        cardWrapper: {
            display: 'flex', 
            flexFlow: 'row wrap',
            alignItems: 'center', 
            gap: '10px',
            flex: 1,
        },
        card: {
            flex: 1,
            padding: '25px 15px',
            display: 'flex',
            flexFlow: 'column',
            gap: '2px',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '230px',
            height: '100%',
            textAlign: 'center',
            position: 'relative',
        },
        cardTitle: {
            color: mainTheme.TemplateColor.Primary,
        },
        cardValue: {
            fontSize: '16px',
            // fontWeight: 600,
        },
        cardInfo: {
            top: '5px',
            right: '5px',
            position: 'absolute',
            color: 'orange'
        },
        tooltip: {
            fontSize: '14px',
            padding: '10px',
            fontFamily: 'Nunito, Arial, Helvetica, sans-serif'
        },
        
        
        actionsWrapper: {
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
            gap: '30px',
            padding: '20px 0px',
        },
        ratingWrapper: {
            display: 'flex',
            flexFlow: 'column',
            gap: '10px',
        },
        rating: {
            frontSize: '2rem',
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            color: mainTheme.TemplateColor.Primary,
            display: 'flex',
            alignItems: 'center',
        },
        headingIcon: {
            marginRight: '10px',
        },
        button: {
            margin: theme.spacing(1),
        },
        // card: {
        //     flex: 1,
        //     padding: '25px 15px',
        //     display: 'flex',
        //     flexFlow: 'column',
        //     gap: '2px',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     maxWidth: '230px',
        //     height: '100%',
        //     textAlign: 'center',
        //     position: 'relative',
        // },
        // cardTitle: {
        //     color: mainTheme.TemplateColor.Primary,
        // },
        // cardValue: {
        //     fontSize: '16px',
        //     // fontWeight: 600,
        // },
        // cardInfo: {
        //     top: '5px',
        //     right: '5px',
        //     position: 'absolute',
        //     color: 'orange'
        // },
        textField: {
            width: '100%',
        },
        enteredBy: {
            fontSize: '13px',
            fontWeight: 600,
            color: '#19750d'
        },
        customDateWrapper: {
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            gap: '5px',
            alignItems: 'flex-start',
            justifyContent: 'center',
        }
    })
);

interface ImportanceLevelFormValues {
    level: number | null;
}

interface FileNotesFormValues {
    notes: string;
}

interface ImportanceLevelDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {
    matterDetails: MatterDetails | null;
    currencySymbol?: string;
    sourceSystem?: string;
    currentUser?: {
        name?: string;
        userId?: string;
        isInternal?: boolean;
    }
}

export function ImportanceLevelDrawer(props: ImportanceLevelDrawerProps) {
    
    const classes = useStyles();
    
    const isPristineImportance = React.useRef<boolean>(false);
    const isPristineFileNotes = React.useRef<boolean>(false);
    
    const [showDiscard, setShowDiscard] = React.useState(false);
    
    const matterMessagesQuery = useQuery<MatterMessageData, MatterMessageDataParams>(MessageQuery, {
        variables: {
            id: props.matterDetails?.id || -1,
        },
        skip: !props.matterDetails,
        fetchPolicy: 'network-only',
    });
    
    const matterOptionQuery = useQuery<MatterOptionQueryData, MatterOptionQueryParams>(MatterOptionQuery, {
        variables: {
            id: props.matterDetails?.id || -1,
        },
        skip: !props.matterDetails,
        fetchPolicy: 'network-only',
    });
    
    const [messages, setMessages] = React.useState<Message[]>([]);
    
    useEffect(() => {
        setMessages(matterMessagesQuery.data?.matter.messages.message ?? []);
    }, [matterMessagesQuery.data, matterMessagesQuery.loading, matterMessagesQuery.error]);
        
    const initialFileNotesFormValues: FileNotesFormValues = {
        notes: '',
    };
    
    const initialImportanceLevelFormValues: ImportanceLevelFormValues = {
        level: props.matterDetails?.importanceLevel ?? null,
    };
    
    const onClose = () => {
                
        if (!isPristineImportance.current || !isPristineFileNotes.current) {
            setShowDiscard(true);
            return;
        } else {
            props.onClose?.({}, 'backdropClick');
        }
        
    }
        
    const onImportanceSubmit = (values: ImportanceLevelFormValues, form: FormApi<ImportanceLevelFormValues, Partial<ImportanceLevelFormValues>>) => {
        
        client.mutate<UpdateMatterMutationResponse, UpdateMatterMutationVariables>({
            mutation: UPDATE_MATTER_MUTATION,
            variables: {
                input: {
                    guid: props.matterDetails!.matterGuid || '',
                    importanceLevel: values.level,
                }
            }
        }).then((response) => {
            if (response.data?.matter.updateMatter.update.status) {
                showNotification(null, 'Importance level updated successfully', 'info');
                form.setConfig('keepDirtyOnReinitialize', false);
                form.reset(values);
                props.onClose?.({}, 'backdropClick');
                form.setConfig('keepDirtyOnReinitialize', true); 
            }
        })
        .catch((error) => {
            showNotification('Failed to update importance level', error.message, 'error');
        });;
        
    };
    
    const onFileNotesSubmit = (values: FileNotesFormValues, form: FormApi<FileNotesFormValues, Partial<FileNotesFormValues>>) => {
        client.mutate<any, MessageMutationParams>({
            mutation: MessageMutation,
            variables: {
                subject: "",
                comment: values.notes || '',
                isInternal: matterOptionQuery.data?.options.matterOptions.canCreateInternalMessage || false,
                matterId: props.matterDetails!.id,
                postedTime: new Date(),
            }
        })
        .then((results) => {
            if (results.data && results.data.createPendingComment) {
                
                const newMessage: Message = {
                    date: new Date(),
                    subject: null,
                    comment: values.notes || '',
                    pending: true,
                    source: 0,
                    title: null,
                    enteredBy: props.currentUser?.name || '',
                    enteredByUserId: props.currentUser?.userId || '',
                };

                setMessages([newMessage, ...messages]);

                form.setConfig('keepDirtyOnReinitialize', false);
                form.reset();
                form.resetFieldState('notes');
                form.setConfig('keepDirtyOnReinitialize', true); 

                showNotification(null, 'File note successfully submitted', 'info');

                // form.change('isSubmitting', false);       
                         
            } else {
                showNotification(null, 'Failed to file note', 'error');
            }
            // tslint:disable-next-line:no-any
        }).catch((reason: any) => {
            // tslint:disable-next-line:no-console
            console.log(reason);
        });
    };
    
    const onDiscardChanges = () => (agree: boolean) => {
        if (agree) {
            setShowDiscard(false);

            if (props.onClose) {
                props.onClose({}, 'backdropClick');
            }
        } else {
            setShowDiscard(false);
        }
    };
        
    const onRequired = (value: ImportanceLevelFormValues) => (value ? undefined : 'Required');
          
   
    const fieldsPanel = (form: FormApi<ImportanceLevelFormValues>, submitting: boolean, pristine: boolean, values: ImportanceLevelFormValues) => {
        return (
            <Accordion
                defaultExpanded={true}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                <Typography className={classes.heading}>
                    <ViewHeadlineIcon 
                        className={classes.headingIcon}
                    />
                    Fields
                </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Field
                                name="level"
                                // validate={form.getFieldState('assignTo')?.value !== null ? required : undefined}
                            >
                                {({ input, meta }) => (
                                    <div
                                        className={classes.ratingWrapper}
                                    >
                                        <Typography 
                                            component="label"
                                        >
                                            Importance Level
                                        </Typography>
                                        <Rating
                                            {...input}
                                            onChange={(event, newValue) => {
                                                input.onChange(newValue ?? 0);
                                            }}
                                            max={5}
                                            size="large"
                                            className={classes.rating}
                                        />
                                    </div>
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={submitting || pristine}
                        className={classes.button}
                    >
                        Save
                    </Button>
                </AccordionActions>
            </Accordion>
        )
    };
    
    const newFileNotePanel = (form: FormApi<FileNotesFormValues>, submitting: boolean, pristine: boolean, values: FileNotesFormValues) => {
        
        return (
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                        <SpeakerNotesIcon className={classes.headingIcon} />
                        New File Note 
                    </Typography>

                    {/* <div className={classes.infoContainer}>
                        <div className="col">
                            <div className="value">{panelTitle}</div>
                        </div>
                    </div> */}
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container={true} spacing={2}>
                        <Grid item={true} xs={12} md={12}>
                            <Field
                                name="notes"
                                validate={onRequired}
                            >
                                {({ input, meta }) => (
                                    <TextField 
                                        {...input}
                                        // label="Notes" 
                                        // required={true}
                                        multiline={true}
                                        variant="outlined"
                                        minRows={4}
                                        className={classes.textField}
                                        error={meta.error && meta.touched}
                                        helperText={
                                            meta.error &&
                                            meta.touched
                                                ? 'Notes is required'
                                                : ''
                                        }
                                    />
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={submitting || pristine}
                    >
                        Save File Note
                    </Button>
                </AccordionActions>
            </Accordion>
        );
    };
    
    const dateRenderer = (msg: Message) => {
        return (
            <div
                className={classes.customDateWrapper}
            >
                    <span>{moment(msg.date).format('D MMM YYYY')}</span>
                    {msg.enteredBy ? (
                        <span 
                            className={classes.enteredBy}
                        >
                            {msg.enteredBy}
                        </span>
                    ) : null}
            </div>
        );
    };
    
    const fileNotesDetailsTable = () => {

        return (
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <Typography className={classes.heading}>
                        <RecentActorsIcon className={classes.headingIcon} />
                        File Notes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {matterMessagesQuery.loading ? (
                        <SkeletonTablePanel 
                            columnLength={2}
                            enabledPaper={false}
                        />
                    ) : (
                        <Grid container={true} spacing={1}>
                            <Grid item={true} xs={12} md={12}>
                                <DataTables 
                                    columns={[
                                        {
                                            key: 'date',
                                            label: 'Date',
                                            type: 'string',
                                            cellRenderer: dateRenderer,
                                        },
                                        {
                                            key: 'comment',
                                            label: 'File Note',
                                            type: 'string',
                                        },
                                    ]}
                                    data={messages}
                                    maxHeight={250}
                                />
                            </Grid>
                        </Grid>
                    )}
                </AccordionDetails>
            </Accordion>
        );
    };
    
    const initializeComponent = () => {
        
        const { financials, forecasts } = props.matterDetails || {};

        const feeEstimate = financials ? financials.feeEstimate : 0;
        const billedTimeAndFees = financials ? financials.billedTimeAndFees : 0;
        const unbilledTimeAndFees = financials ? financials.unbilledTimeAndFees : 0;
        const unbilledDisbursements = financials ? financials.unbilledDisbursements : 0;
        const billableHours = financials ? financials.billableHours : 0;
        const nonBillableHours = financials ? financials.nonBillableHours : 0;
        const standardValue = financials ? financials.standardValue : 0;
        const profitability = financials ? financials.profitability : 0;
        const { totalFutureFeesBilled, totalFutureFeesCollected, totalFutureHours } = forecasts || {};
        
        const remianingEstimate = feeEstimate - billedTimeAndFees;

        const isEstimatedFeesRed = billedTimeAndFees > feeEstimate;

        let isRemaningEstimateRed = false;

        let isFeesCollectedRed = false;
        
        if (totalFutureFeesBilled) {
            isRemaningEstimateRed = totalFutureFeesBilled > remianingEstimate;
        }

        if (totalFutureFeesCollected && totalFutureFeesBilled) {
            isFeesCollectedRed = totalFutureFeesBilled !== totalFutureFeesCollected;
        }
        
        return (
            <div className={classes.cardContainer}>
                <div className={classes.cardWrapper}>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        {isEstimatedFeesRed ? (
                            <LightTooltip 
                                classes={{
                                    tooltip: classes.tooltip
                                }}
                                title="Billed time & fees exceeds estimate"
                            >
                                <InfoIcon 
                                    className={classes.cardInfo}
                                />
                            </LightTooltip>
                        ) : null}
                        <Typography className={classes.cardTitle}>Estimated Fees</Typography>
                        <Typography 
                            className={classes.cardValue}
                            style={{
                                color: isEstimatedFeesRed ? 'red' : 'inherit'
                            }}
                        >
                            {`${props.currencySymbol}${formatNumber(feeEstimate, 0)}`}
                        </Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Billed Time & Fees</Typography>
                        <Typography className={classes.cardValue}>{`${props.currencySymbol}${formatNumber(billedTimeAndFees, 0)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        {isRemaningEstimateRed ? (
                            <LightTooltip 
                                classes={{
                                    tooltip: classes.tooltip
                                }}
                                title="Total forecast billed fees exceeds remaining fee estimate"
                            >
                                <InfoIcon 
                                    className={classes.cardInfo}
                                />
                            </LightTooltip>
                        ) : null}
                        <Typography className={classes.cardTitle}>Remaining Estimate</Typography>
                        <Typography 
                            className={classes.cardValue}
                            style={{
                                color: isRemaningEstimateRed ? 'red' : 'inherit'
                            }}
                        >
                            {`${props.currencySymbol}${formatNumber(remianingEstimate >= 0 ? remianingEstimate : 0, 0)}`}
                        </Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Total Fees Billed Forecast</Typography>
                        <Typography className={classes.cardValue}>{`${props.currencySymbol}${formatNumber(totalFutureFeesBilled || 0, 0)}`}</Typography>
                    </Paper>
                </div>
                <div className={classes.cardWrapper}>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Unbilled Time & Fees</Typography>
                        <Typography className={classes.cardValue}>{`${props.currencySymbol}${formatNumber(unbilledTimeAndFees, 0)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Unbilled Disbursements</Typography>
                        <Typography className={classes.cardValue}>{`${props.currencySymbol}${formatNumber(unbilledDisbursements, 0)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Total Hours Forecast</Typography>
                        <Typography className={classes.cardValue}>{`${formatNumber(totalFutureHours || 0, 2)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        {isFeesCollectedRed ? (
                            <LightTooltip 
                                classes={{
                                    tooltip: classes.tooltip
                                }}
                                title="Total Fees Collected Forecast is different from the Total Fees Billed Forecast"
                            >
                                <InfoIcon 
                                    className={classes.cardInfo}
                                />
                            </LightTooltip>
                        ) : null}
                        <Typography className={classes.cardTitle}>Total Fees Collected F'cast</Typography>
                        <Typography 
                            className={classes.cardValue}
                            style={{
                                color: isFeesCollectedRed ? 'red' : 'inherit'
                            }}
                        >
                            {`${props.currencySymbol}${formatNumber(totalFutureFeesCollected || 0, 0)}`}
                        </Typography>
                    </Paper>
                </div>
                <div className={classes.cardWrapper}>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Billable Hours</Typography>
                        <Typography className={classes.cardValue}>{`${formatNumber(billableHours || 0, 2)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Non-Billable Hours</Typography>
                        <Typography className={classes.cardValue}>{`${formatNumber(nonBillableHours || 0, 2)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Standard Value</Typography>
                        <Typography className={classes.cardValue}>{`${props.currencySymbol}${formatNumber(standardValue || 0, 0)}`}</Typography>
                    </Paper>
                    <Paper
                        elevation={3}
                        className={classes.card}
                    >
                        <Typography className={classes.cardTitle}>Profitability</Typography>
                        <Typography className={classes.cardValue}>{`${formatNumber(profitability || 0, 2)}%`}</Typography>
                    </Paper>
                </div>
            </div>  
        );
    };
    
    return (
        <>
            <DialogBox
                title="Discard Changes"
                content="Are you sure you want to close the form?"
                show={showDiscard}
                isAgree={onDiscardChanges()}
                disAgreeLabel="No"
                agreeLabel="Yes"
            />
            <Drawer 
                open={props.open || false}
                classes={{
                    paper: classes.root,
                }}
                anchor="right"
                onClose={onClose}
            >
                {matterMessagesQuery.loading || matterOptionQuery.loading ? (
                    <div className={classes.loaderWrapper}>
                        <RvLoader />
                    </div>
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.agWrapper}>
                                <div className={classes.infoBody}>
                                    <div className={classes.infoContainer}>
                                        <Typography
                                            style={{ fontSize: '24px', fontWeight: 'bold' }}
                                        >
                                            {props.matterDetails?.title}
                                        </Typography>
                                        <div className={classes.infoWrapper}>
                                            <div className={classes.infoTitle}>{props.matterDetails?.fileNumber}</div>
                                            <div className={classes.infoValue}>{props.matterDetails?.client}</div>
                                        </div>
                                    </div>
                                    <div className={classes.learnMoreContainer}>
                                        {/* <Button 
                                            variant="text" 
                                            color="primary" 
                                            size="small" 
                                            onClick={onLearnMore} 
                                            startIcon={<VideoLibraryOutlinedIcon />}
                                        >
                                            Learn More
                                        </Button> */}
                                    </div>
                                </div>
                                {initializeComponent()}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Form<ImportanceLevelFormValues>
                                onSubmit={onImportanceSubmit}
                                initialValues={initialImportanceLevelFormValues}
                                initialValuesEqual={() => true}
                                // keepDirtyOnReinitialize={true}
                                subscription={{ submitting: true, pristine: true, values: true }}
                                render={({ handleSubmit, form, submitting, pristine, values}) => {
                                    
                                    console.log('pristine', pristine);
                                    isPristineImportance.current = pristine;
                                    
                                    return (
                                        <>

                                            <form 
                                                onSubmit={handleSubmit}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        {fieldsPanel(form, submitting, pristine, values)}
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Form<FileNotesFormValues>
                                onSubmit={onFileNotesSubmit}
                                initialValues={initialFileNotesFormValues}
                                initialValuesEqual={() => true}
                                // keepDirtyOnReinitialize={true}
                                subscription={{ submitting: true, pristine: true, values: true }}
                                render={({ handleSubmit, form, submitting, pristine, values}) => {
                                    
                                    isPristineFileNotes.current = pristine;
                                    
                                    return (
                                        <>
                                    
                                            <form 
                                                onSubmit={handleSubmit}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        {newFileNotePanel(form, submitting, pristine, values)}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {fileNotesDetailsTable()}
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </>
                                    );
                                }}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <div
                                className={classes.actionsWrapper}
                            >
                                <Button
                                    type="button"
                                    variant="contained"
                                    onClick={onClose}
                                    className={classes.button}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                )}
            </Drawer>
        </>
    );
}


interface UpdateMatterInput {
    guid: string;
    importanceLevel: number | null;
}

interface UpdateMatterMutationVariables {
    input: UpdateMatterInput | null;
};

interface UpdateMatterMutationResponse {
    matter: {
        updateMatter: {
            update: {
                error: string | null;
                status: string;
            }
        }
    }
}

const UPDATE_MATTER_MUTATION = gql`
    mutation UpdateMatter($input: UpdateMatterInput){
        matter {
            updateMatter {
            update (input: $input) {
                error
                status
            }
            }
        }
    } 
`;

type MatterMessageDataParams = {
    id: number;
};

type MatterMessageData = {
    matter: MatterMessage;
};

type MatterMessage = {
    id:       number;
    messages: Messages;
};

type Messages = {
    recordCount: number;
    message:     Message[];
};

type Message = {
    date:            Date;
    subject:         null | string;
    comment:         string;
    pending:         boolean;
    source:          number;
    title:           null | string;
    enteredBy:       string;
    enteredByUserId: string;
};

const MessageQuery = gql`
    query MessageData($id: Int!) {
        matter(id: $id) {
            id
            messages {
                recordCount
                message {
                    date
                    subject
                    comment
                    pending
                    source
                    title
                    enteredBy
                    enteredByUserId
                }
            }
        }
    }
`;

type MessageMutationParams = {
    subject: string;
    comment: string;
    isInternal: boolean;
    matterId: number;
    postedTime: Date;
};

const MessageMutation = gql`mutation 
        ($subject: String, $comment: String!, $isInternal: Boolean, $matterId: Int!, $postedTime: DateTime) {
    createPendingComment
        (subject: $subject, comment: $comment, isInternal: $isInternal, matterId: $matterId, postedTime: $postedTime)
}`;

type MatterOptionQueryParams = {
    id: number;
};

type MatterOptionQueryData = {
    options: Options;
};

type Options = {
    matterOptions: MatterOptions;
};

type MatterOptions = {
    canCreateInternalMessage: boolean;
    canCreateMessageSubject:  boolean;
};

const MatterOptionQuery = gql`
    query MatterOptionsQuery($id: Int!) {
        options {
            matterOptions(matterId: $id) {
                canCreateInternalMessage
                canCreateMessageSubject
            }
        }
    }
`;


// type MatterForecastParams = {
//     matterId: number;
// };

// type MatterForecastData = {
//     matter: Matter;
// };

// type Matter = {
//     id:               number;
//     matterGuid:       string;
//     fileNumber:       string;
//     acting:           string;
//     actingEmail:      string;
//     responsible:      string;
//     responsibleEmail: string;
//     client:           string;
//     description:      string;
//     title:            string;
//     completionDate:   Date;
//     financials:       Financials;
//     forecasts:        Forecasts;
// };

// type Financials = {
//     unbilledTimeAndFees:   number;
//     unbilledDisbursements: number;
//     debtors:               number;
//     trustBalance:          number;
//     billedTimeAndFees:     number;
//     feeEstimate:           number;
//     percentageEstimate:    number;
// };

// type Forecasts = {
//     totalFutureHours: number;
//     totalFutureFeesBilled: number;
//     totalFutureFeesCollected: number;
//     matterForecast: MatterForecast[];
// };

// type MatterForecast = {
//     guid:          string;
//     matterId:      number;
//     periodType:    number;
//     feesBilled:    number;
//     feesCollected: number;
//     hours:         number;
//     startDate:     Date;
// };

// const MatterForecastQuery = gql`
//     query matterDetails($matterId: Int!) {
//         matter(id: $matterId) {
//             id
//             matterGuid
//             fileNumber
//             acting
//             actingEmail
//             responsible
//             responsibleEmail
//             client
//             description
//             title
//             completionDate
//             financials {
//                 unbilledTimeAndFees
//                 unbilledDisbursements
//                 debtors: balanceDue
//                 trustBalance: trustGeneralBalance
//                 billedTimeAndFees
//                 feeEstimate: estimatedCosts
//                 percentageEstimate
//             }
//             forecasts{
//                 totalFutureHours
//                 totalFutureFeesBilled
//                 totalFutureFeesCollected
//                 matterForecast{
//                     guid
//                     matterId
//                     periodType
//                     feesBilled
//                     feesCollected
//                     hours
//                     startDate
//                 }
//             }
//         }
//     }
// `;